module.exports = __webpack_public_path__ + "static/media/IMG_0102.bfa953fa.JPG";